<ng-container *transloco="let t">
  <li class="slide">
    <a
      (click)="sidebarClose()"
      class="side-menu__item fw-medium"
      [class.locked]="papLocked"
      [routerLink]="routerLinkFactory.dashboard()"
      routerLinkActive="active"
    >
      <span class="side-menu__icon">
        <span class="sidemenu_icon material-symbols-rounded"> grid_view </span>
        <span class="lock-badge" *ngIf="papLocked">
          <i class="material-symbols-rounded filled">lock</i>
        </span>
      </span>
      <span class="side-menu__label">{{ t('shared/dashboard') }}</span>
    </a>
  </li>

  <li class="slide">
    <a
      (click)="sidebarClose()"
      class="side-menu__item fw-medium"
      [class.locked]="papLocked"
      [routerLink]="routerLinkFactory.portfolio()"
      routerLinkActive="active"
    >
      <span class="side-menu__icon">
        <span class="sidemenu_icon material-symbols-rounded"> school </span>
        <span class="lock-badge" *ngIf="papLocked">
          <i class="material-symbols-rounded filled">lock</i>
        </span>
      </span>
      <span class="side-menu__label">{{ t('portfolio/title') }}</span>
    </a>
  </li>

  <li class="slide">
    <a
      (click)="sidebarClose()"
      class="side-menu__item fw-medium"
      [class.locked]="papLocked"
      [routerLink]="routerLinkFactory.plan()"
      routerLinkActive="active"
    >
      <span class="side-menu__icon">
        <span class="sidemenu_icon material-symbols-rounded"> inventory </span>
        <span class="lock-badge" *ngIf="papLocked">
          <i class="material-symbols-rounded filled">lock</i>
        </span>
      </span>
      <span class="side-menu__label">{{ t('plan/title') }}</span>
    </a>
  </li>

  <li class="slide">
    <a
      (click)="sidebarClose()"
      class="side-menu__item fw-medium"
      [class.locked]="papLocked"
      [routerLink]="routerLinkFactory.result()"
      routerLinkActive="active"
    >
      <span class="side-menu__icon">
        <span class="sidemenu_icon material-symbols-rounded"> leaderboard </span>
        <span class="lock-badge" *ngIf="papLocked">
          <i class="material-symbols-rounded filled">lock</i>
        </span>
      </span>
      <span class="side-menu__label">{{ t('result/title') }}</span>
    </a>
  </li>
  <li class="slide" *ngIf="teachersResults?.length > 0 && selectedResult?.isCurrentCompetencyFramework !== false">
    <a
      (click)="sidebarClose()"
      class="side-menu__item fw-medium"
      [class.locked]="papLocked"
      [routerLink]="routerLinkFactory.recommendations()"
      routerLinkActive="active"
    >
      <span class="side-menu__icon">
        <span class="sidemenu_icon material-symbols-rounded"> emoji_objects </span>
        <span class="lock-badge" *ngIf="papLocked">
          <i class="material-symbols-rounded filled">lock</i>
        </span>
      </span>
      <span class="side-menu__label">{{ t('recommendations/recommendation') }}</span>
    </a>
  </li>

  <!--  <li class="slide">-->
  <!--    <a-->
  <!--      class="side-menu__item"-->
  <!--      [class.disabled]="!hasResults"-->
  <!--      [routerLink]="hasResults ? routerLinkFactory.recommendation(selectedChild) : null"-->
  <!--      routerLinkActive="active"-->
  <!--      [routerLinkActiveOptions]="{ exact: true }"-->
  <!--    >-->
  <!--      <i class="fe fe-target sidemenu_icon"></i>-->
  <!--      <span class="side-menu__label">{{ t('shared/supportAreas') }}</span>-->
  <!--    </a>-->
  <!--  </li>-->

  <!-- <li class="slide">
    <a
      class="side-menu__item"
      [class.disabled]="!hasResults"
      [routerLink]="hasResults ? routerLinkFactory.participation() : null"
      routerLinkActive="active"
    >
      <span class="sidemenu_icon material-symbols-rounded"> license </span>
      <span class="side-menu__label">{{ t('info/participation') }}</span>
    </a>
  </li> -->
</ng-container>
